<template>
  <card-panel :paddinglessContent="!!allReferralsListState.length" class="referrals-panel-container">
    <span v-translate slot="header-name">Referrals</span>
    <card-panel-items-amount-counter
      slot="header-counter"
      :amount="allReferralsListState.length"
      :isNeedReview="isSomeReferralNeedReview && featureSwitchesState.REFERRAL_DETAILS">
    </card-panel-items-amount-counter>

    <div slot="content">
      <card-panel-list v-if="allReferralsListState.length">
        <referral-list-item v-for="(referral, index) in allReferralsListState"
                            :key="index"
                            :item="referral"
                            :tokens="tokensByReferralIdState[referral.id]">
        </referral-list-item>
      </card-panel-list>
      <referrals-not-found v-else></referrals-not-found>
    </div>
  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';
import CardPanelItemsAmountCounter from 'top20common/components/card-panel/CardPanelItemsAmountCounter';
import CardPanelList from 'top20common/components/card-panel/CardPanelList';
import {mapGetters} from 'vuex';

import ReferralListItem from './ReferralListItem';
import ReferralsNotFound from './ReferralsNotFound.vue';

export default {
  computed: {
    ...mapGetters([
      'featureSwitchesState',
      'allReferralsListState',
      'tokensByReferralIdState',
      'referralsMetaState',
      'isSomeReferralNeedReview'
    ])
  },
  components: {
    CardPanel,
    CardPanelList,
    CardPanelItemsAmountCounter,
    ReferralListItem,
    ReferralsNotFound
  }
};
</script>

<style lang="scss" scoped>
.referrals-panel-container {
  /deep/ .items-amount-counter {
    margin-left: 5px;
  }
}
</style>
